import React, { useContext, createContext, useReducer, useEffect } from "react";
import initialState from "./reducer/initialState";
import reducer from "./reducer/rootReducer";

const loadFromLocalStorage = () => {
  try {
    const stateStr = localStorage.getItem("SPMS_INTERNAL_STATE");
    return stateStr ? JSON.parse(stateStr) : initialState;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const StateContext = createContext();

const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, loadFromLocalStorage());
  useEffect(() => {
    localStorage.setItem("SPMS_INTERNAL_STATE", JSON.stringify(state));
  }, [state]);
  return (
    <StateContext.Provider value={[state, dispatch]}>
      {children}
    </StateContext.Provider>
  );
};

const useGlobalState = () => useContext(StateContext);

export { StateProvider, useGlobalState as default };
